import { render, staticRenderFns } from "./SavedBuildYourOwnRM.vue?vue&type=template&id=259d171a&scoped=true"
import script from "./SavedBuildYourOwnRM.vue?vue&type=script&lang=js"
export * from "./SavedBuildYourOwnRM.vue?vue&type=script&lang=js"
import style0 from "./SavedBuildYourOwnRM.vue?vue&type=style&index=0&id=259d171a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259d171a",
  null
  
)

export default component.exports